import React from 'react';
import { motion } from 'framer-motion';
import { FiStar, FiMapPin } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import BilingualText from '../common/BilingualText';

const Hero = () => {
  const waLink = "https://wa.me/529841771113?text=Hola! I want to book an appointment / Hola! Quiero agendar una cita.";

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
      {/* Background Video Placeholder */}
      <div className="absolute inset-0 z-0 opacity-40">
        <img src="https://images.unsplash.com/photo-1587779775487-199b00799794?q=80&w=2000&auto=format&fit=crop" alt="Lash Background" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-black via-transparent to-black"></div>
      </div>

      {/* Floating Elements Animation */}
      <motion.div 
        animate={{ y: [0, -20, 0] }}
        transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
        className="absolute top-1/4 right-10 md:right-32 z-10 hidden md:block"
      >
        <div className="bg-black/50 backdrop-blur-md border border-mx-gold/50 p-4 rounded-2xl shadow-xl">
          <div className="flex items-center gap-2 text-mx-gold mb-1">
            <FiStar className="fill-current" />
            <FiStar className="fill-current" />
            <FiStar className="fill-current" />
            <FiStar className="fill-current" />
            <FiStar className="fill-current" />
          </div>
          <p className="text-white text-xs font-bold uppercase">Top Rated in Mexico</p>
        </div>
      </motion.div>

      <div className="relative z-20 max-w-5xl mx-auto px-4 text-center">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="inline-flex items-center gap-2 bg-mx-green/20 border border-mx-green text-mx-green px-4 py-1 rounded-full mb-6 backdrop-blur-sm">
            <span className="w-2 h-2 bg-mx-red rounded-full animate-pulse"></span>
            <span className="text-xs font-bold uppercase tracking-widest text-white">Official Mexico Lash Studio</span>
          </div>
          
          <h1 className="text-5xl md:text-8xl font-serif font-black text-white mb-6 leading-tight">
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-mx-green via-white to-mx-red">MEXICAN</span>
            <span className="block">BEAUTY</span>
          </h1>

          <div className="flex flex-col items-center gap-2 mb-10">
            <p className="text-xl md:text-2xl text-gray-200 font-light max-w-2xl mx-auto">
              Luxury Eyelash Extensions
            </p>
            <p className="text-mx-gold font-serif italic text-lg opacity-90">
              Extensiones de Pestañas de Lujo
            </p>
          </div>

          <div className="flex flex-col md:flex-row gap-4 justify-center items-center">
            <a href={waLink} className="group relative bg-mx-gold text-black px-10 py-4 rounded-full font-black uppercase tracking-widest hover:bg-white transition-all shadow-[0_0_30px_rgba(217,164,65,0.4)] flex items-center gap-3 overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/50 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"></div>
              <FaWhatsapp className="text-2xl" />
              <div className="flex flex-col items-start leading-none">
                <span>Book Appointment</span>
                <span className="text-[10px] opacity-70">Agendar Cita</span>
              </div>
            </a>
            <a href="#services" className="px-10 py-4 rounded-full border border-white text-white font-bold uppercase hover:bg-white hover:text-black transition-all flex flex-col items-center leading-none">
              <span>View Menu</span>
              <span className="text-[10px] opacity-70 font-normal mt-1">Ver Menú</span>
            </a>
          </div>

          <div className="mt-12 flex items-center justify-center gap-2 text-gray-400 text-sm">
            <FiMapPin className="text-mx-red" />
            <span>Cancun • Playa del Carmen • Tulum • CDMX</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;